export default __webpack_public_path__ + "static/media/swd6.3df83cdf.jpg";